/* ================================================================
   APPLICATION.JS
   Global utilities — form logic is inline in application-form.liquid
   ================================================================ */
(function () {
  'use strict';
  /* Placeholder for global JS: analytics, scroll tracking, etc. */
})();
